"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _sideNav = _interopRequireDefault(require("@/components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("@/components/foot-nav"));
var _downguid = _interopRequireDefault(require("@/components/downguid.vue"));
var _priceDialog = _interopRequireDefault(require("@/components/specialVehicle/priceDialog.vue"));
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _api = require("../../api/api");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _util = _interopRequireDefault(require("@/assets/static/js/utils/util.js"));
var _ourTelsData = _interopRequireDefault(require("@/assets/static/js/ourTelsData"));
var _default = exports.default = {
  name: 'specialVehicle',
  components: {
    footNav: _footNav.default,
    sideNav: _sideNav.default,
    downGuid: _downguid.default,
    priceDialog: _priceDialog.default
  },
  data: function data() {
    return {
      telStr: '',
      citys: _appCitysData.default.cityDataWithoutDistrict,
      //出发城市数据
      svForm: {
        startProvince: '',
        // 起始省
        startCity: '',
        // 起始市
        startProvinceId: 0,
        startCityId: 0,
        startCityStr: '',
        // 起始省/市
        endProvince: '',
        // 目的省
        endCity: '',
        // 目的市
        endProvinceId: 0,
        endCityId: 0,
        endCityStr: '',
        // 目的省/市
        goodsType: '',
        // 货物类型
        goodsWeight: '',
        // 货物重量
        goodsName: '',
        // 货物名称
        vehicleType: '',
        // 车型
        concactName: '',
        // 姓名
        concactPhone: '',
        // 手机号
        carGoodsNo: '',
        // 编号
        companyName: '',
        // 公司名称
        companyType: '',
        // 公司类型
        demandType: '',
        // 需求类型
        biddingFlag: '',
        // 是否招标
        prepictCost: '0元/吨、0元/车',
        // 预估运费
        freight: '',
        // 期望运费
        freightUnit: '0',
        // 期望运费单位
        remark: '',
        // 要求/备注
        customerSourse: '1' // 来源-0:平台,1:PC,2:电话沟通,3:APP
      },
      svRules: {
        concactPhone: [{
          required: true,
          message: '请输入电话号码',
          trigger: 'blur'
        }, {
          pattern: /^1\d{10}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
        startCityStr: [{
          required: true,
          message: '请选择出发城市',
          trigger: 'change'
        }],
        endCityStr: [{
          required: true,
          message: '请选择到达城市',
          trigger: 'change'
        }],
        goodsWeight: [{
          required: true,
          message: '请输入货物重量',
          trigger: 'blur'
        }],
        freight: [{
          required: true,
          message: '请输入期望运费',
          trigger: 'blur'
        }]
      },
      verificationCode: '',
      // 验证码
      showPrice: false,
      priceLoading: true,
      showPhone: false
    };
  },
  computed: {
    isLogin: function isLogin() {
      if (!this.$root.dialogFormVisible) {
        console.log(this.hasToken());
        if (this.hasToken()) {
          this.getUserInfo();
        }
        return true;
      }
      return false;
    }
  },
  created: function created() {
    // 判断用户是否有登录
    this.toLogin();
  },
  methods: {
    /*********************************************** Event *******************************************************/getTel: function getTel(startProvince) {
      var telsData = _ourTelsData.default.telsData;
      var tel = '400-886-3156';
      if (telsData.length > 0) {
        telsData.filter(function (item) {
          if (item.cityArr.includes(startProvince)) {
            console.log(item.tel);
            tel = item.tel;
          }
        });
      }
      this.telStr = tel;
      console.log("getTel:", this.telStr);
    },
    //选择出发城市
    startCityChange: function startCityChange(value) {
      var that = this;
      that.svForm.startProvince = value[0];
      if (value.length > 0 && value[1]) {
        that.svForm.startCity = value[1] == '全省' ? '' : value[1];
      }
      that.svForm.startCityStr = _util.default.joinCityAndDistrict(that.svForm.startProvince, that.svForm.startCity, '/');
      that.getStartCityId(that.citys, value, 0);
      that.getTel(that.svForm.startProvince);
    },
    //选择到达城市
    endCityChange: function endCityChange(value) {
      var that = this;
      that.svForm.endProvince = value[0];
      if (value.length > 0 && value[1]) {
        that.svForm.endCity = value[1] == '全省' ? '' : value[1];
      }
      that.svForm.endCityStr = _util.default.joinCityAndDistrict(that.svForm.endProvince, that.svForm.endCity, '/');
      this.getEndCityId(this.citys, value, 0);
    },
    // 获取出发城市id
    getStartCityId: function getStartCityId(citys, arr, n) {
      var _this = this;
      citys.filter(function (item) {
        if (item.label == arr[n]) {
          if (item.label == arr[0]) {
            _this.svForm.startProvinceId = item.value;
          }
          if (item.children) {
            n++;
            return _this.getStartCityId(item.children, arr, n);
          } else {
            _this.svForm.startCityId = item.value;
          }
        }
      });
    },
    // 获取到达城市id
    getEndCityId: function getEndCityId(citys, arr, n) {
      var _this2 = this;
      citys.filter(function (item) {
        if (item.label == arr[n]) {
          if (item.label == arr[0]) {
            _this2.svForm.endProvinceId = item.value;
          }
          if (item.children) {
            n++;
            return _this2.getEndCityId(item.children, arr, n);
          } else {
            _this2.svForm.endCityId = item.value;
          }
        }
      });
    },
    // 提交并校验
    submitForm: function submitForm(formName) {
      var _this3 = this;
      var that = this;
      that.$refs[formName].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(valid, obj) {
          var key;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!valid) {
                  _context.next = 8;
                  break;
                }
                // 再次判断用户是否有登录
                that.toLogin();
                if (!(0, _cookie.getCookie)('user')) {
                  _context.next = 6;
                  break;
                }
                _context.next = 5;
                return that.getPrice();
              case 5:
                that.getSpecialMessage();
              case 6:
                _context.next = 12;
                break;
              case 8:
                // 验证失败
                console.log('error submit!!', obj);
                // 取错误信息对象里的第一个数组,抛出错误提示
                key = Object.keys(obj)[0];
                _this3.$message({
                  message: obj[key][0].message,
                  type: 'error',
                  duration: '3000'
                });
                return _context.abrupt("return", false);
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 未登录弹出登录窗
    toLogin: function toLogin() {
      var that = this;
      var userStorage = (0, _cookie.getCookie)('user');
      if (!userStorage) {
        this.$root.loginscene = 'SCG'; //注册登录场景
        that.$root.dialogFormVisible = true;
      }
    },
    // 查价弹窗关闭
    closePriceDialog: function closePriceDialog() {
      this.showPrice = false;
    },
    // 联系弹窗-显示
    showCallDialog: function showCallDialog() {
      this.showPrice = false;
      this.showPhone = true;
    },
    // 判断是否有token
    hasToken: function hasToken() {
      return (0, _cookie.getCookie)('token') ? true : false;
    },
    /*********************************************** Request *****************************************************/
    // 表单保存口
    getSpecialMessage: function () {
      var _getSpecialMessage = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var jsonParam, _yield$apiGetSpecialM, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              jsonParam = {
                jsonParamete: JSON.stringify({
                  fun: "saveSpecialCarGoods",
                  param: {
                    jsondata: JSON.stringify(this.svForm),
                    verificationCode: this.verificationCode
                  },
                  version: 1
                })
              };
              _context2.next = 3;
              return (0, _api.apiGetSpecialMessage)(jsonParam);
            case 3:
              _yield$apiGetSpecialM = _context2.sent;
              data = _yield$apiGetSpecialM.data;
              if (data.proCode == '200') {
                // this.svForm.carGoodsNo = data.proData.carGoodsNo
                // 展示查价弹窗
                this.showPrice = true;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getSpecialMessage() {
        return _getSpecialMessage.apply(this, arguments);
      }
      return getSpecialMessage;
    }(),
    //获取预估价格
    getPrice: function () {
      var _getPrice = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var param, jsonParam, _yield$apiGetRewordPr, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.svForm.endCityId && this.svForm.startCityId)) {
                _context3.next = 8;
                break;
              }
              param = {
                "fun": "getGoodsPrepictCost",
                "param": {
                  "startCityId": this.svForm.startCityId,
                  "endCityId": this.svForm.endCityId
                },
                "version": 1
              };
              jsonParam = {
                jsonParamete: JSON.stringify(param)
              };
              _context3.next = 5;
              return (0, _api.apiGetRewordPrice)(jsonParam);
            case 5:
              _yield$apiGetRewordPr = _context3.sent;
              data = _yield$apiGetRewordPr.data;
              if (data.proCode == '200') {
                this.priceLoading = false;
                if (data.proData.proData && data.proData.proData.minYT && data.proData.proData.minPrice) {
                  this.svForm.prepictCost = data.proData.proData.minYT + '~' + data.proData.proData.maxYT + '元/吨、' + data.proData.proData.minPrice + '~' + data.proData.proData.maxPrice + '元/车';
                }
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getPrice() {
        return _getPrice.apply(this, arguments);
      }
      return getPrice;
    }(),
    // 获取用户信息
    getUserInfo: function () {
      var _getUserInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, param, jsonParam, _yield$apiGetBusiness, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              that = this;
              param = {
                version: 1,
                fun: 'getBusinessCardInformation',
                param: {}
              };
              jsonParam = {
                jsonParamete: JSON.stringify(param)
              };
              _context4.next = 5;
              return (0, _api.apiGetBusinessCardInformation)(jsonParam);
            case 5:
              _yield$apiGetBusiness = _context4.sent;
              data = _yield$apiGetBusiness.data;
              if (data.proCode == 200) {
                console.log("getUserInfo:", data);
                if (data.proData.name && data.proData.name != 'null') {
                  // 姓名
                  that.svForm.concactName = data.proData.name;
                } else {
                  that.svForm.concactName = '';
                }
                if (data.proData.contact && data.proData.contact != 'null') {
                  // 手机号
                  that.svForm.concactPhone = data.proData.contact;
                } else {
                  that.svForm.concactPhone = '';
                }
                if (data.proData.companyName && data.proData.companyName != 'null') {
                  that.svForm.companyName = data.proData.companyName; // 公司名称
                } else {
                  that.svForm.companyName = '';
                }
              }
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }
      return getUserInfo;
    }(),
    /*********************************************** Others *****************************************************/
    // 锚点滚动
    goAnchor: function goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView({
        behavior: "smooth",
        // 平滑过渡
        block: "start" // 上边框与视窗顶部平齐。默认值
      });
    }
  }
};